import { isE2ETest, isLocal } from '~/utils/env';

// (example)
// export const NAME_OF_THE_FEATURE = 'NAME_OF_THE_FEATURE';
export const EQUIPMENT_ALLOW_PERSONAL = 'EQUIPMENT_ALLOW_PERSONAL';
export const AI_PROFILE_BUILDER = 'AI_PROFILE_BUILDER';
export const DEPOSITS_CUSTOMER = 'DEPOSITS_CUSTOMER';
export const BACKGROUND_CHECKS = 'BACKGROUND_CHECKS';
export const NOT_MATCH_FLAG = 'NOT_MATCH_FLAG';

type Alternative = boolean | ((user: any) => boolean);

const alternatives: Record<string, Alternative> = {};

export function isEnabled(feature: string, user?: any): boolean {
    if (window.FEATURE_FLAGS?.includes?.(feature)) {
        return true;
    }

    if (import.meta.env[`VITE_${feature}`] === 'on') {
        return true;
    } else if (import.meta.env[`VITE_${feature}`] === 'off') {
        return false;
    }

    if (isLocal() && !isE2ETest()) return true;

    return typeof alternatives[feature] === 'function'
        ? alternatives[feature](user)
        : alternatives[feature];
}
